import * as React from 'react';
import { AbstractFilterView, OptionsFilterViewProps } from './AbstractFilterView';
import { FilterSelect } from './Dropdown/FilterSelect';

export interface DropdownFilterProps<VALUE_TYPE, OPTION_TYPE> extends OptionsFilterViewProps<VALUE_TYPE, OPTION_TYPE> {
}

export class DropdownFilter<VALUE_TYPE extends string | number, OPTION_TYPE>
    extends AbstractFilterView<VALUE_TYPE, DropdownFilterProps<VALUE_TYPE, OPTION_TYPE>> {
    protected renderInput(): JSX.Element | null {
        const props = this.props;
        const options = props.options;
        const value = props.filter ? props.filter.value : undefined;

        return <FilterSelect value={value} onChange={this.handleChange} options={options}/>;
    }
}
